import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, filter } from 'rxjs';
import { DeviceStatus, isAutomFwUpdateInProgress, isDeviceUnavailable } from 'src/app/model/device-status';
import { SafetyInputCategory, getSafetyInputIcon } from 'src/app/model/safety-input';
import { StandardDesignParameters } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { selectCurrentDeviceSafetyInputs, selectCurrentDeviceStatus, selectSafetyInputsLoading } from 'src/app/store/device/device.selector';


@Component({
	selector: 'app-safety-inputs',
	templateUrl: './safety-inputs.component.html',
	providers: [],
})
export class SafetyInputsComponent implements OnInit, OnDestroy {
	safetyInputs$: Observable<SafetyInputCategory[] | undefined>;
	safetyInputsSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription;
	safetyInputsLoading$: Observable<boolean | undefined>;
	safetyInputsLoadingSub: Subscription;

	
	loading: boolean;
	offline = true;
	deviceStatus: DeviceStatus;
	opened = false;
	categories: SafetyInputCategory[];

	getInputIcon = getSafetyInputIcon;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_WIDTH_MX7 = 1700;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService
	) {
		this.initSelectors();
	}


	initSelectors(): void{
		// Store selectors
		this.safetyInputs$ = this.store.select(selectCurrentDeviceSafetyInputs);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.safetyInputsLoading$ = this.store.select(selectSafetyInputsLoading);
	}

	ngOnInit() {
		this.safetyInputsLoadingSub = this.safetyInputsLoading$.subscribe(loading => {
			this.loading = loading;
		});
		this.safetyInputsSub  = this.safetyInputs$.subscribe(categories => {
			this.categories = categories;
		});
		this.deviceStatusSub = this.deviceStatus$.pipe(
			filter(ds => !!ds),
		).subscribe(ds => {
			this.deviceStatus = ds;
			this.offline = isDeviceUnavailable(ds);
		});
		this.onResize();
	}

	ngOnDestroy() {
		this.safetyInputsSub?.unsubscribe();
		this.safetyInputsSub?.unsubscribe();
		this.safetyInputsLoadingSub?.unsubscribe();
	}

	loadInputs() {
		this.store.dispatch(DeviceActions.getSafetyInputs());
	}

	togglePanel(opened: boolean) {
		this.opened = opened;
		if (this.opened && !this.offline) {
			this.loadInputs();
		}
	}

	getCategory(category): string {
		if (category === "wired") {
			return this.translate.instant("WIRED");
		}
		return category;
	}

	isAutomFwUpdateInProgress(): boolean {
		return isAutomFwUpdateInProgress(this.deviceStatus);
	}

	unavailableAlertKey(): string {
		return this.isAutomFwUpdateInProgress() ? 'DEVICE_FW_UPDATE_IN_PROGRESS_ALERT' : 'OFFLINE_ALERT';
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return (this.screenWidth <= StandardDesignParameters.MIN_MD_WIDTH);
	}
}
